import { defineStore } from 'pinia'
import { ref, watch } from 'vue'

export type Theme = 'dark' | 'light'

export const useThemeStore = defineStore('theme', () => {
  const currentTheme = ref<Theme>('dark')

  // Тёмная тема — брендовая по умолчанию; светлая включается пользователем
  // в панели доступности и сохраняется в localStorage. Системную тему не учитываем.
  const initTheme = () => {
    const savedTheme = localStorage.getItem('theme')
    setTheme(savedTheme === 'light' ? 'light' : 'dark')
  }

  // Применение темы
  const applyTheme = (theme: Theme) => {
    const html = document.documentElement
    
    // Удаляем предыдущие атрибуты темы
    html.removeAttribute('data-theme')
    
    if (theme === 'light') {
      html.setAttribute('data-theme', 'light')
    }
    // Для темной темы не устанавливаем атрибут, так как это значения по умолчанию
  }

  // Переключение темы
  const toggleTheme = () => {
    const newTheme = currentTheme.value === 'dark' ? 'light' : 'dark'
    setTheme(newTheme)
  }

  // Установка конкретной темы
  const setTheme = (theme: Theme) => {
    currentTheme.value = theme
    localStorage.setItem('theme', theme)
    applyTheme(theme)
  }

  // Следим за изменениями темы и применяем их
  watch(currentTheme, (newTheme) => {
    applyTheme(newTheme)
  })

  return {
    currentTheme,
    initTheme,
    toggleTheme,
    setTheme,
    applyTheme
  }
}) 